<template>
  <div id="app">
    <ug-programmes :ugProgrammes="ugProgrammes" v-if="level === 'ug'" />
    <pg-programmes :pgProgrammes="pgProgrammes" v-if="level === 'pg'" />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Programmes from "./components/Programmes.vue";
import UgProgrammes from "./components/UgProgrammes.vue";
import PgProgrammes from "./components/PgProgrammes.vue";

import axios from "axios";

const pgProgUrl = "https://www.wgtn.ac.nz/endpoints/pg-programmes";
const ugProgUrl = "https://www.wgtn.ac.nz/endpoints/ug-programmes";
const gradQuals = "https://www.wgtn.ac.nz/endpoints/grad-quals";
const otherQuals = "https://www.wgtn.ac.nz/endpoints/other-quals";

//for local
// const pgList = require('./assets/pg.json')
// const ugList = require('./assets/ug.json')

//for prod
// const pgList = window.pg
// const ugList = window.ug

// console.log('pglist', pgList);
// console.log('uglist', ugList);

export default {
  name: "app",
  components: {
    // HelloWorld,
    Programmes,
    UgProgrammes,
    PgProgrammes,
  },
  data() {
    return {
      loading: true,
      ugProgrammes: [],
      pgProgrammes: [],
      level: "",
    };
  },
  methods: {
    fetchData() {
      console.log("fetching data...");
      axios
        .all([
          axios.get(pgProgUrl),
          axios.get(ugProgUrl),
          axios.get(gradQuals),
          axios.get(otherQuals),
        ])
        .then(([pg, ug, gq, other]) => {
          console.log("UGENDPOINT", ug.data.items);
          console.log("PG ENDPOINT", pg.data.items);
          console.log("gradquals", gq.data.items);

          let filteredOther = other.data.items
            .filter((course) => Object.keys(course).length !== 0)
            .filter((course) => {
              return course.name.includes("Profic") ? course : "";
            });

                console.log('other', filteredOther);

          const joinedPgProg = [...pg.data.items, ...gq.data.items, ...filteredOther];
          const joinedUgProg = [...ug.data.items, ...gq.data.items, ...filteredOther];
          console.log("joined PG", joinedPgProg);
          console.log("joined UG", joinedUgProg);

          this.ugProgrammes = joinedUgProg;
          this.pgProgrammes = joinedPgProg;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
      // this.ugProgrammes = ugList.items;
      // this.ugProgrammes = window.ug;

      // this.pgProgrammes = pgList.items;
      // this.pgProgrammes = window.pg;
    },
    setLevel() {
      this.level = window.level;
      // this.level = 'ug'
      console.log("Level is ", this.level);
    },
  },
  mounted() {
    this.fetchData();
    this.setLevel();
  },
};
</script>

<style lang="scss">
#app {
  .programmes-wrap > .block {
    padding-top: 0;
  }

  .c-stack-body {
    .meta--labelled {
      margin-bottom: 0;
    }
  }
  .c-stack-code {
    font-size: 1.2rem;
  }

  .c-stack-short {
    flex-direction: column;

    .c-stack-fig {
      width: 100%;
      border-right: none;
      max-width: none;
      min-width: none;
    }
    .c-stack-code,
    .c-stack-title,
    .c-stack-intro {
      margin-bottom: 0.5rem;
    }

    .meta--labelled {
      margin-top: 1rem;
    }

    .meta-item {
      margin-bottom: 0;
      margin-right: 2rem;
      flex: 0 1 auto;

      display: flex;
      align-items: baseline;

      .meta-label {
        margin-right: 1rem;
        margin-bottom: 0;
      }
    }

    @media (max-width: 42.99em) {
      .c-stack-fig {
        width: auto;

        .c-stack-code {
          margin-bottom: 0;
        }
      }

      .meta-item {
        align-items: initial;
      }
    }
  }
}
</style>
